<template>
    <div class="p-3">
        <div class="appoitmentsList getStartd ">
            <div class="row justify-content-center ">
                <div class="col-12 col-md-10">
                    <div class="clientTop-Section bg-white border-radius-5  d-flex align-items-center justify-content-between flex-wrap">
                        <div class="welcomeTitle p-5  col-12 col-md-6">
                            <h3>Hello {{ get_user.profile.firstname ||''}}, Welcome to Gini Health 🎉</h3>
                            <p>We provide best healthcare at Affordable pricing so that you can live longer and healthier</p>
                            <div class="buttonSection"><router-link to="/book-appointment" class="btn-blue d-flex align-items-center medium Button-new">Book Appointment</router-link></div>
                        </div>
                        <div class="welcomeImage col-12 col-md-6 d-flex justify-content-end"><img src="../../../../static/website/images/welcome-image.svg" class="WelcomeImage" alt="WelcomeImage"></div>  
                    </div>
                    <div class="quickStart bg-white border-radius-5 p-3 position-relative">
                        <div class="quickTitle px-5  col-12 mb-3">
                            <div class=" border-bottom pb-3 d-flex">
                                <span class="quickNo">2</span>
                                <h3 class="mb-0">Quick Start</h3>
                            </div>
                        </div>
                        <div class="startedList px-5">
                            <div class=" border-bottom pb-3 mb-3 d-flex justify-content-between align-items-center">
                                <div class="started">
                                    <h4 class="mb-0">Book Your First Appointment</h4>
                                    <p>Contact with our best doctors and researchers from the world's best institutes to make the best health protocols. Our doctors are the heroes that deliver our evidence based care.</p>
                                </div>
                                <div>
                                    <router-link to="/appointment-list" class="btn btn-link firstAppointment">View appointments</router-link>
                                </div>
                            </div>
                            <!-- <div class=" border-bottom pb-3 mb-3 d-flex justify-content-between align-items-center">
                                <div>
                                    <h4 class="mb-0">Gini Diabetes Reversal Program</h4>
                                    <p>Take charge of yourself and achive your health goals with personalised & clinically-validated <br /> wellness programs.</p>
                                </div>
                                <div>
                                    <router-link to="" class="btn btn-link firstAppointment">Enroll Now</router-link>
                                </div>
                            </div> -->
                            <!-- <div class=" border-bottom pb-3 mb-3 d-flex justify-content-between align-items-center">
                                <div>
                                    <h4 class="mb-0">Book Lab Test with Gini health</h4>
                                    <p>Book a test anytime and anywhere with our Gini Lab.</p>
                                </div>
                                <div>
                                    <router-link to="" class="btn btn-link firstAppointment">Book Now</router-link>
                                </div>
                            </div> -->
                            <div class=" border-bottom pb-3 mb-3 d-flex justify-content-between align-items-center">
                                <div>
                                    <h4 class="mb-0">Upload Lab Test Report</h4>
                                    <p>upload your lab test report and consult with our best doctor’s.</p>
                                </div>
                                <div>
                                    <router-link to="/upload-test-reports" class="btn btn-link firstAppointment">Upload Lab Test</router-link>
                                </div>
                            </div>
                            <div class="pb-3 d-flex justify-content-between align-items-center">
                                <div>
                                    <h4 class="mb-0">Upload Old Prescription</h4>
                                    <p>get a valid prescription</p>
                                </div>
                                <div>
                                    <router-link to="/upload-test-reports" class="btn btn-link firstAppointment">Upload Prescriptions</router-link>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    export default {
        name: "Get-Started",
        data() {
            return {
            }
        },
        created(){
            this.pageName('Get Started')
        }

    }
</script>


// WEBPACK FOOTER //
// src/components/website/get_started/get_started.vue